<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="housekeepingServInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="housekeepingServInfo.conditions.servName" placeholder="请输入服务名称" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="housekeepingServInfo.conditions.hktId" placeholder="请选择服务类型" style="width:100%"
                clearable>
                <el-option v-for="item in housekeepingServInfo.housekeepingTypes" :key="item.hktId"
                  :label="item.hktName" :value="item.hktId" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="housekeepingServInfo.conditions.repairWay" placeholder="请选择派单方式" style="width:100%"
                clearable>
                <el-option v-for="item in housekeepingServInfo.repairWays" :key="item.statusCd" :label="item.name"
                  :value="item.statusCd" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryHousekeepingServMethod">
              <i class="el-icon-search"></i> 查询
            </el-button>
            <el-button @click="_resetHousekeepingServMethod">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>家政服务</span>
        <div style="float: right;">
          <el-button type="primary" size="small" @click="_openAddHousekeepingServModal">
            <i class="el-icon-plus"></i> 添加
          </el-button>
<!--          <el-button type="primary" size="small" style="margin-left:10px"-->
<!--            @click="_openAddHousekeepingFeeConfigRel('', '')">-->
<!--            <i class="el-icon-plus"></i> 创建费用-->
<!--          </el-button>-->
        </div>
      </div>
      <div class="card-body">
        <el-table :data="housekeepingServInfo.housekeepingServs" border style="width: 100%">
          <el-table-column prop="servId" label="服务编号" align="center" />
          <el-table-column prop="servName" label="服务名称" align="center" />
          <el-table-column prop="servDesc" label="服务描述" align="center" />
          <el-table-column prop="hktName" label="服务类型" align="center" />
          <el-table-column label="派单方式" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.repairWay === '100'">抢单</span>
              <span v-else-if="scope.row.repairWay === '200'">指派</span>
              <span v-else-if="scope.row.repairWay === '300'">轮训</span>
            </template>
          </el-table-column>
          <el-table-column label="回访方式" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.returnVisitFlag === '001'">都不回访</span>
              <span v-else-if="scope.row.returnVisitFlag === '002'">已评价不回访</span>
              <span v-else-if="scope.row.returnVisitFlag === '003'">都回访</span>
            </template>
          </el-table-column>
          <el-table-column prop="sales" label="销量" align="center" />
          <el-table-column prop="defaultFee" label="默认费用" align="center" />
          <el-table-column prop="marketPrice" label="市场价" align="center" />
          <el-table-column prop="sort" label="排序" align="center" />
          <el-table-column label="上架状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.state === '1001' ? '未上架' : '上架' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditHousekeepingServModel(scope.row)">修改</el-button>
              <el-button size="mini" type="danger" @click="_openDeleteHousekeepingServModel(scope.row)">删除</el-button>
              <el-button size="mini" @click="_viewServDetail(scope.row)">查看</el-button>
              <el-button size="mini" @click="_openHousekeepingFeeConfigManageRel(scope.row)">查看费用</el-button>
              <el-button size="mini" @click="_openHousekeepingServUser(scope.row)">维修师傅</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" :current-page="housekeepingServInfo.conditions.page"
          :page-size="housekeepingServInfo.conditions.row" layout="total, prev, pager, next"
          :total="housekeepingServInfo.total" />
      </div>
    </el-card>

    <delete-housekeeping-serv ref="deleteHousekeepingServ" @refresh="_listHousekeepingServs"></delete-housekeeping-serv>
    <add-housekeeping-fee-config-rel ref="addHousekeepingFeeConfigRel"></add-housekeeping-fee-config-rel>
    <view-qrcode ref="viewQrcode"></view-qrcode>
  </div>
</template>

<script>
import { queryHousekeepingServ, queryHousekeepingType } from '@/api/housekeeping/housekeepingServApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import viewQrcode from '@/components/system/viewQrcode'

export default {
  name: 'HousekeepingServ',
  components: {
    'delete-housekeeping-serv': () => import('@/components/housekeeping/deleteHousekeepingServ'),
    'add-housekeeping-fee-config-rel': () => import('@/components/housekeeping/addHousekeepingFeeConfigRel'),
    viewQrcode
  },
  data() {
    return {
      housekeepingServInfo: {
        housekeepingServs: [],
        total: 0,
        records: 1,
        moreCondition: false,
        servId: '',
        componentShow: 'housekeepingServ',
        housekeepingTypes: [],
        repairWays: [],
        conditions: {
          repairWay: '',
          servName: '',
          hktId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      this.housekeepingServInfo.conditions.shopId = getShopId()
      this._listHousekeepingServs()
      this._listHousekeepingTypes()
      try {
        const {data} = await getDict('housekeeping_serv', 'repair_way')
        this.housekeepingServInfo.repairWays = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listHousekeepingServs() {
      try {
        const res = await queryHousekeepingServ(this.housekeepingServInfo.conditions)
        this.housekeepingServInfo.total = res.total
        this.housekeepingServInfo.records = res.records
        this.housekeepingServInfo.housekeepingServs = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _listHousekeepingTypes() {
      try {
        const params = {
          page: 1,
          row: 50,
          typeCd: 1001,
          shopId: getShopId()
        }
        const res = await queryHousekeepingType(params)
        this.housekeepingServInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _openAddHousekeepingServModal() {
      this.$router.push('/pages/housekeeping/addHousekeepingServ')
    },
    _openEditHousekeepingServModel(housekeepingServ) {
      this.$router.push(`/pages/housekeeping/editHousekeepingServ?servId=${housekeepingServ.servId}`)
    },
    _openDeleteHousekeepingServModel(housekeepingServ) {
      this.$refs.deleteHousekeepingServ.open(housekeepingServ)
    },
    _queryHousekeepingServMethod() {
      this.housekeepingServInfo.conditions.page = 1
      this._listHousekeepingServs()
    },
    _resetHousekeepingServMethod() {
      this.housekeepingServInfo.conditions = {
        repairWay: '',
        servName: '',
        hktId: '',
        shopId: getShopId(),
        page: 1,
        row: 10
      }
      this._listHousekeepingServs()
    },
    _openAddHousekeepingFeeConfigRel(servId, servName) {
      this.$refs.addHousekeepingFeeConfigRel.open({ _servId: servId, _servName: servName })
    },
    _openHousekeepingFeeConfigManageRel(housekeepingServ) {
      this.$router.push(`/pages/housekeeping/housekeepingServFeeConfigManageRel?servId=${housekeepingServ.servId}&servName=${housekeepingServ.servName}`)
    },
    _openHousekeepingServUser(housekeepingServ) {
      this.$router.push(`/pages/housekeeping/housekeepingServUserManage?servId=${housekeepingServ.servId}&servName=${housekeepingServ.servName}`)
    },
    _viewServDetail(serv) {
      console.log(serv)
      this.$refs.viewQrcode.open({
        qrcodeName: serv.servName,
        qrCodeUrl: serv.pageUrl,
        remark: '手机扫码查看家政服务'
      })
    },
    handleCurrentChange(val) {
      this.housekeepingServInfo.conditions.page = val
      this._listHousekeepingServs()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>